// extracted by mini-css-extract-plugin
module.exports = {"chip-in-button":"chip_in_button__chip-in-button___2z03j","preview":"chip_in_button__preview___12_fM"};